const HOME = "/admin_chatbot"
const ROUTER = {
  CHAT: "/",
  CHATCD: "/chat-cd",
  SVG_VIEWER: "/svg-viewer",
  HOME: "/admin_chatbot",
  DANG_NHAP: `${HOME}/dang-nhap`,
  DANG_KY: `${HOME}/dang-ky`,
  DOI_MAT_KHAU: `${HOME}/doi-mat-khau`,
  ACCOUNT: `${HOME}/tai-khoan`,
  CHAT_AI: `${HOME}/chat-ai`,
  CHAT_AI_PUBLIC: "/:id",
  //ANONYMOUS
  PROCEDURE: "/procedure",

  // ADMIN
  QUAN_LY_TAI_KHOAN: "/quan-ly-tai-khoan",
  QUAN_LY_TAI_LIEU: `${HOME}/quan-ly-tai-lieu`,
  QUAN_LY_NGUOI_DUNG: `${HOME}/quan-ly-nguoi-dung`,
  QUAN_LY_AI: `${HOME}/quan-ly-AI`,
  CAI_DAT: `${HOME}/cai-dat`,
  CAP_NHAT_IDE: `${HOME}/cap-nhat-ide`,
  LICH_SU_CHAT: `${HOME}/lich-su-chat`,
  LICH_SU_LOI: `${HOME}/lich-su-loi`,
}
export default ROUTER
